import {
    LIST_USERS,
    LIST_USERS_SUCCESS,
    LIST_USERS_ERROR,
    ADD_USERS,
    SAVE_USERS,
    SAVE_USERS_SUCCESS,
    SAVE_USERS_ERROR,
    EDIT_USERS,
    ENABLE_USERS,
    ENABLE_USERS_SUCCESS,
    ENABLE_USERS_ERROR,
    UPDATE_USERS,
    UPDATE_USERS_SUCCESS,
    UPDATE_USERS_ERROR,
    DELETE_USERS,
    DELETE_USERS_SUCCESS,
    DELETE_USERS_ERROR,
    RESET_PASS_USERS,
    RESET_PASS_USERS_ERROR,
    RESET_PASS_USERS_SUCCESS,
    GET_RESET_PASS_TOKEN,
    GET_RESET_PASS_TOKEN_SUCCESS,
    GET_RESET_PASS_TOKEN_ERROR,
    RESET_PASS_TOKEN,
    RESET_PASS_TOKEN_ERROR,
    RESET_PASS_TOKEN_SUCCESS
} from '../types';

// Cada reducer tiene su propio state
const initialState = {    
    actualPage: null,
    error: null,
    errorSave: null,
    isEdit: false,
    isFirst: null,
    isLast: null,
    loading: false,
    loadingSave: false,
    total: null,
    totalPages: null,
    users: null, 
    userSelected: null
}


export default function(state = initialState, action) {
    switch(action.type) {
        case LIST_USERS:
        case GET_RESET_PASS_TOKEN:
            return {
                ...state,
                loading: true
            }
        case LIST_USERS_ERROR:
        case GET_RESET_PASS_TOKEN_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                users: action.payload.content,
                actualPage: action.payload.number,
                isLast: action.payload.last,
                isFirst: action.payload.first,
                total: action.payload.totalElements,
                totalPages: action.payload.totalPages
            }
        case ENABLE_USERS:
        case SAVE_USERS:
        case DELETE_USERS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_USERS:
        case RESET_PASS_USERS:
        case RESET_PASS_TOKEN:
            return {
                ...state,
                loadingSave: true
            }
        case ENABLE_USERS_ERROR:
        case SAVE_USERS_ERROR:
        case UPDATE_USERS_ERROR:
        case DELETE_USERS_ERROR:
        case RESET_PASS_USERS_ERROR:
        case RESET_PASS_TOKEN_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_USERS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                users: [...state.users, action.payload]
            }
        case ADD_USERS:
            return {
                ...state,
                userSelected: null,
                isEdit: false
            }
        case EDIT_USERS:
            return {
                ...state,
                userSelected: action.payload,
                isEdit: true
            }
        case UPDATE_USERS_SUCCESS:
        case DELETE_USERS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                users: state.users.map(user => 
                    user.id === action.payload.id ? user = action.payload : user
                ),
                userselected: null
            }
        case ENABLE_USERS_SUCCESS:
            return {
                ...state,
                error: false,
                errorSave: false,
                users: state.users.map(user => 
                    user.id === action.payload.id ? user = action.payload : user
                ),
                isEdit: false,
                loading: false, 
                loadingSave: false
            }    
        case RESET_PASS_USERS_SUCCESS:
        case RESET_PASS_TOKEN_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null
            }
        case GET_RESET_PASS_TOKEN_SUCCESS:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}